<template>
   <div class="demo">
       <div class="page">
         <v-container>
           <h3 style="margin-bottom:50px">Useful Links:</h3>
             <v-layout row wrap>
               <v-flex xs12 md6 lg3 @click="redirect('http://europa.eu/')"> 
                 <v-card class="hover-light" >
                   
          <img
          class="card-image"
          src="../../assets/link-logo/eu_logo.jpg"
          >

        <v-card-title primary-title>
         
            <h3 class="headline mb-0" style="margin-left: auto;margin-right: auto;">European Union</h3>
           
          
        </v-card-title>
                 </v-card>
                 
               </v-flex>

                              <v-flex xs12 md6 lg3 @click="redirect('http://www.romania-serbia.net/')"> 
                 <v-card class="hover-light" >
                   
          <img
          class="card-image"
          style="height: 80px;"
          src="../../assets/logo2.png"
          >

        <v-card-title primary-title>
         
            <h3 class="headline mb-0" style="margin-left: auto;margin-right: auto;">Interreg-IPA CBC Romania-Serbia</h3>
           
          
        </v-card-title>
                 </v-card>
                 
               </v-flex>

                              <v-flex xs12 md6 lg3 @click="redirect('http://www.gov.ro/')"> 
                 <v-card class="hover-light" >
                   
          <img
          class="card-image"
          src="../../assets/link-logo/sigla_guv_coroana_gri.png"
          >

        <v-card-title primary-title>
         
            <h3 class="headline mb-0" style="margin-left: auto;margin-right: auto;">The Government of Romania</h3>
           
          
        </v-card-title>
                 </v-card>
                 
               </v-flex>

                                             <v-flex xs12 md6 lg3 @click="redirect('https://www.uvt.ro/ro/')"> 
                 <v-card class="hover-light" >
                   
          <img
          class="card-image"
          src="../../assets/link-logo/uvt_logo.png"
          >

        <v-card-title primary-title>
         
            <h3 class="headline mb-0" style="margin-left: auto;margin-right: auto;">West University of Timișoara</h3>
           
          
        </v-card-title>
                 </v-card>
                 
               </v-flex>


                              <v-flex xs12 md6 lg3 @click="redirect('https://www.srbija.gov.rs/')"> 
                 <v-card class="hover-light" >
                   
          <!-- <img
          class="card-image"
          src="../../assets/link-logo/sigla_guv_coroana_gri.png"
          > -->

        <v-card-title primary-title>
         
            <h3 class="headline mb-0" style="margin-left: auto;margin-right: auto;">The Government of The Republic of Serbia</h3>
           
          
        </v-card-title>
                 </v-card>
                 
               </v-flex>




                              <v-flex xs12 md6 lg3 @click="redirect('http://www.kikinda.org.rs')"> 
                 <v-card class="hover-light" >
                   
          <!-- <img
          class="card-image"
          src="../../assets/link-logo/uvt_logo.png"
          > -->

        <v-card-title primary-title>
         
            <h3 class="headline mb-0" style="margin-left: auto;margin-right: auto;">City of Kikinda</h3>
           
          
        </v-card-title>
                 </v-card>
                 
               </v-flex>


                                             <v-flex xs12 md6 lg3 @click="redirect('http://www.muzejkikinda.com')"> 
                 <v-card class="hover-light" >
                   
          <!-- <img
          class="card-image"
          src="../../assets/link-logo/uvt_logo.png"
          > -->

        <v-card-title primary-title>
         
            <h3 class="headline mb-0" style="margin-left: auto;margin-right: auto;">The Kikinda National Museum</h3>
           
          
        </v-card-title>
                 </v-card>
                 
               </v-flex>


             </v-layout>

             </v-container>
        </div>
   </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        // {
        //   title: "European Union",
        //   href:"http://europa.eu/",
        //   avatar:"../../assets/link-logo/ec-logo-horiz-web_en.jpg"
        // },
        // {
        //     title:"Interreg-IPA CBC Romania-Serbia",
        //     href:"http://www.romania-serbia.net/"
        // },
        // {
        //     title:"The Government of Romania",
        //     href:"http://www.gov.ro/"
        // },
        // {
        //     title:"The Government of The Republic of Serbia",
        //     href:"https://www.srbija.gov.rs/"
        // },
        // {
        //     title:"West University of Timișoara",
        //     href:"https://www.uvt.ro/ro/"
        // },
        // {
        //     title:"City of Kikinda",
        //     href:"http://www.kikinda.org.rs"
        // },
        // {
        //     title:"The Kikinda National Museum",
        //     href:"http://www.muzejkikinda.com"
        // }
      ]
    };
  },
  methods:{
      redirect(href){
          window.location.href = href;
      }
  }
};
</script>

<style scoped>
</style>

<style>
.hover-light:hover{
  opacity: 0.5;
}
.hover-light {
  margin:10px;
  height: 220px !important;
  transition: all 0.5s ease-out;
  cursor: pointer;
}
.card-image{
padding-top:20px;
height: 100px;
display: block;
margin-left: auto;
margin-right: auto;
  
}
</style>



// WEBPACK FOOTER //
// src/components/Common/Links.vue